import { combineReducers } from "@reduxjs/toolkit";
import generalReducer from "./generalReducer";
import ticketReducer from "./ticketReducer";

export default combineReducers({
  general: generalReducer,
  ticket: ticketReducer,
});
